import { withInstall } from '@jdesign-vue/utils'
import InputNumber from './src/input-number.vue'

export const JdInputNumber = withInstall(InputNumber)

export default JdInputNumber
export * from './src/input-number'
